import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { createI18n } from 'vue-i18n'

// 导入语言包
import zh from './locales/zh'
import vi from './locales/vi'
import ja from './locales/ja'
import ko from './locales/ko'
import id from './locales/id'
import th from './locales/th'
import pt from './locales/pt'
import tr from './locales/tr'
import ar from './locales/ar'
import es from './locales/es'
import hi from './locales/hi'
import fr from './locales/fr'
import ms from './locales/ms'
import fil from './locales/fil'
import de from './locales/de'
import it from './locales/it'
import ru from './locales/ru'
import sv from './locales/sv'
import no from './locales/no'
import da from './locales/da'
import en from './locales/en'

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: localStorage.getItem('lang') || 'en', // 默认语言为英语
  fallbackLocale: 'en', // 设置备用语言
  messages: {
    zh,
    en,
    ja,
    ar,
    vi,
    ko,
    id,
    th,
    pt,
    tr,
    es,
    hi,
    fr,
    ms,
    fil,
    de,
    it,
    ru,
    sv,
    no,
    da
  }
})

const app = createApp(App)

app.use(store)
app.use(router)
app.use(ElementPlus)
app.use(i18n)

// 在路由守卫中获取 URL 参数并设置语言
router.beforeEach((to, from, next) => {
  const lang = to.query.pick || 'en' // 获取 URL 中的 lang 参数，默认 'en'
  i18n.global.locale.value = lang // 更新 i18n 语言
  next() // 继续路由导航
})

app.mount('#app')
